/* eslint-disable max-len */
import React, {PropsWithChildren} from 'react';
import Box from '@material-ui/core/Box';
import styled from 'styled-components';

const IconBackground = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 24px;
  border: 1px solid #076CAC;

  svg {
    g {
      fill: #076CAC;
    }
  }
`;

export const InfoIcon = (props: PropsWithChildren<any>) => {
    return (
        <IconBackground>
            <svg width="30px" height="13px" viewBox="0 0 5 13" {...props}>
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none"
                    fillRule="evenodd">
                    <g id="dropdown---group-class"
                        transform="translate(-301.000000, -162.000000)"
                        fill="#FFFFFF">
                        <g id="default-screen"
                            transform="translate(0.000000, 80.000000)">
                            <g id="groups"
                                transform="translate(218.000000, 67.000000)">
                                <g id="info-btn"
                                    transform="translate(75.000000, 12.000000)">
                                    <path
                                        d="M11.5849324,8 C11.7151186,8 11.8206826,8.12098192 11.8206826,8.2699824 L11.8206826,13.8245929 C11.8206826,13.9306748 11.88054,14.0244479 11.9688402,14.0568393 L12.8518424,14.3802676 C12.9401426,14.412497 13,14.5064321 13,14.612352 L13,15.7301796 C13,15.87918 12.894436,16 12.7641082,16 L8.23589178,16 C8.10556405,16 8,15.87918 8,15.7301796 L8,14.563279 C8,14.4549298 8.06240448,14.359699 8.15339333,14.3292511 L8.97880229,14.0537621 C9.06964963,14.0234762 9.13205411,13.9280835 9.13205411,13.8198962 L9.13205411,10.2944455 C9.13205411,9.89198224 8.84691798,9.56563879 8.49527367,9.56563879 L8.14150676,9.56563879 C8.06339503,9.56563879 8,9.49308203 8,9.40368174 L8,8.16195705 C8,8.07255676 8.06339503,8 8.14150676,8 L11.5849324,8 Z M9.99989655,3 C11.1045363,3 12,3.90098731 12,5.01197605 C12,6.12317292 11.1045363,7.0239521 9.99989655,7.0239521 C8.89525681,7.0239521 8,6.12317292 8,5.01197605 C8,3.90098731 8.89525681,3 9.99989655,3 Z"
                                        id="icon_info">
                                    </path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </IconBackground>
    );
};
